import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import createAttachmentFiles from '../../utils/createAttachmentFiles';
import { replyToMeeting } from 'owa-reply-to-meeting';
import type { AttachmentDetails } from 'owa-addins-core';
import type { ViewType } from 'owa-calendar-actions';

export default function displayReplyForm(event: CalendarEvent) {
    return (
        referenceItemId: string,
        isReplyAll: boolean,
        htmlBody: string,
        attachments: AttachmentDetails[]
    ) => {
        const source: ViewType = 'ReadForm';
        const attachmentFilesToUpload = createAttachmentFiles(attachments);
        replyToMeeting(event, isReplyAll, source, htmlBody, attachmentFilesToUpload);
    };
}
